const colors = {
    "cs-purple": [
        "#fce9ff",
        "#ebc2f1",
        "#dc9be4",
        "#cc73d8",
        "#be4ccd",
        "#a533b4",
        "#81278c",
        "#5c1b64",
        "#380f3d",
        "#150318",
    ],
    "cs-teal": [
        "#ddfaff",
        "#b3ecfd",
        "#86def8",
        "#5ad1f4",
        "#35c4f1",
        "#23abd7",
        "#1585a8",
        "#075f79",
        "#00394a",
        "#00151c",
    ],
    "cs-green": [
        "#d9fffc",
        "#adfff3",
        "#7dffeb",
        "#4dffe4",
        "#25ffdc",
        "#14e6c2",
        "#00b397",
        "#00806c",
        "#004e41",
        "#001c16",
    ],
    "cs-gray": [
        "#f1f1fc",
        "#d8d8de",
        "#bcbfc2",
        "#a3a5a8",
        "#898b8f",
        "#707275",
        "#57585c",
        "#3e3f43",
        "#23262a",
        "#001010",
    ],
    "cs-red": [
        "#ffe5e9",
        "#f9bbc3",
        "#ef909c",
        "#e76475",
        "#df394e",
        "#c62034",
        "#9b1729",
        "#6f0f1c",
        "#45070f",
        "#1e0003",
    ],
    "cs-orange": [
        "#ffe9e1",
        "#ffc5b3",
        "#fba084",
        "#f87a54",
        "#f55524",
        "#db3c0b",
        "#ab2e07",
        "#7b2004",
        "#4b1200",
        "#1e0400",
    ],
    "cs-yellow": [
        "#ffffda",
        "#ffffad",
        "#fffe7d",
        "#fffe4b",
        "#fffe1a",
        "#e6e400",
        "#b3b200",
        "#807f00",
        "#4d4c00",
        "#1b1900",
    ],
    "truecare-primary": [
        "#e4f4ff",
        "#bfdbf2",
        "#9ac2e5",
        "#73aad9",
        "#4e92cd",
        "#3578b4",
        "#285d8d",
        "#1a4365",
        "#0c283f",
        "#000e1a",
    ],
    "truecare-secondary": [
        "#defbfb",
        "#c0eced",
        "#9ddcde",
        "#78cdd0",
        "#56bfc3",
        "#3ca5a9",
        "#2b8184",
        "#1b5d5f",
        "#063839",
        "#001517",
    ],
    "bayou-primary": [
        "#fff2dc",
        "#fdd9b2",
        "#f8c184",
        "#f5a856",
        "#f18f27",
        "#d8760e",
        "#a85c08",
        "#794005",
        "#4a2600",
        "#1e0b00",
    ],
    "bayou-secondary": [
        "#d8ffff",
        "#acfffe",
        "#7dfffc",
        "#4dfffb",
        "#27fffa",
        "#17e6e0",
        "#00b3ae",
        "#00807d",
        "#004e4c",
        "#001c1b",
    ],
    "bayou-accent": [
        "#fff7db",
        "#ffe8af",
        "#ffd97f",
        "#ffca4d",
        "#ffbb1d",
        "#e6a106",
        "#b37d00",
        "#805a00",
        "#4e3600",
        "#1d1100",
    ],
};

export default colors;
